import gql from "graphql-tag";
import {LocationFragment} from "./Location";

export const LiveFlightFragment = gql`
fragment LiveFlightFragment on FlightNode {
    _id,
    desig,
    departureID {
        _id
        name
    }
    aircraftID {
        _id
        maxSeats
    }
    legs
    firstLegUsableWt
    state
    contract {
        _id
        name
    }
    legsArray {
        seats
        paxWeight
        departureID
        destinationID
    }
    paxIDList {
        _id
    }
    cgoIDList {
        _id
    }
    estDepartureTime
    _linkedDispatchByContract {
        _id
        ata
        ato
        eta
        departingDoc {
            ...LocationFragment
        }
        destinationDoc {
            ...LocationFragment
        }
    }
    weatherDelayTs
}
${LocationFragment}
`